import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
const LockedIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/dist/esm/lens/Locked.js"));
function LockedStepIcon(props) {
    const { completed, active } = props;
    const { tokens: { semantic, component }, } = useTheme();
    const { stepper } = component;
    return (_jsx(Box, Object.assign({ sx: Object.assign(Object.assign({ width: stepper.step.icon.width.value, height: stepper.step.icon.height.value, borderRadius: semantic.radius.full.value, display: "flex", alignItems: "center", justifyContent: "center" }, (active
            ? applyTokens(stepper.step.icon.active)
            : applyTokens(stepper.step.icon.default))), (completed && Object.assign({}, applyTokens(stepper.step.icon.completed)))) }, { children: _jsx(LockedIcon, {}) })));
}
export const StepperPresets = () => {
    return {
        components: {
            LockedStepIcon: LockedStepIcon,
        },
    };
};
//# sourceMappingURL=stepper.js.map